import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { addPriceBook, getAllPriceBook, getAllPriceBookList, savePriceBookLine, updatePriceBook } from "./PriceBookRepo"
import { toast } from "react-toastify"
import { showToast } from "../../utils/toastUtils"

interface AllPriceBookInterface {
    enable:boolean,
    params:{
        orgUnitId?:number,
        search?:string
        priceBookId?:number,
        page?:number,
        limit?:number,
    }
}


export const useGetALlPriceBook = ({enable=false,params}:AllPriceBookInterface)=>{
    return useQuery({
        queryKey:['GET_ALL_PRICEBOOK',params],
        queryFn:()=>getAllPriceBook(params),
        retry:false,
        enabled:enable
    })
}


interface ReqBody {
    PriceBookName:string,
    orgUnitId:number,
    description:string
}

export const useAddPriceBook = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:({ReqBody}:{ReqBody:ReqBody})=>addPriceBook({ReqBody}),
        onSuccess:()=>{
            showToast.success('Price Book added Successfully!');
            queryClient.invalidateQueries({queryKey:['GET_ALL_PRICEBOOK']})
        },

        onError:(error:any)=>{
            console.log('Failed to Add Please try agin later',error.message);
            showToast.error('Failed to add PriceBook',)
        }
    })
}


export const useUpdatePriceBook = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:({ReqBody,id} : {ReqBody:any,id:number})=>updatePriceBook({ReqBody,id}),
        onSuccess:()=>{
            showToast.success('Price book lines have been updated successfully')
            queryClient.invalidateQueries({queryKey:['GET_ALL_PRICEBOOK']})
        },
        onError:(error:any)=>{
            console.log('Failed to Upadate PriceBook',error.message);
            showToast.error('Faield to Update PriceBook',)
        }
    })
}

export const useGETPriceBookList = ({
    enable = false,
    id,
    page,
    limit,
    search,
    brand_id,
    category_id
  }: {
    enable: boolean,
    id: number,
    page: number,
    limit: number,
    search?: string,
    brand_id?:number | string,
    category_id?:number | string
  }) => {
    return useQuery({
      queryKey: ['GET_PRICEBOOK_LIST', id, page, limit, search,brand_id,brand_id,category_id],
      queryFn: () => getAllPriceBookList(id, page, limit, search,brand_id,category_id),
      enabled: enable,
      retry: false,
    });
  };
  
  


export const useUpdateMultiplePriceBookLines = ()=>{
   const queryClient = useQueryClient();

   return useMutation({
    mutationFn:({ReqBody,id}:{ReqBody:any,id:number})=>savePriceBookLine({ReqBody,id}),
    onSuccess:()=>{
        showToast.success('PriceBook Lines is UpdatedSuccessully!');
        queryClient.invalidateQueries({queryKey:['GET_PRICEBOOK_LIST']});
    },
    onError:(error:any)=>{
        console.log('Failed to Update Pricebook Line',error.message);
        showToast.error('Failed to Update PriceBook Line')
    }

   })
}
